import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({
  get: () => '',
  save: async () => {},
  isEditor: false,
  loaded: false,
});

export function ContentProvider({ children }) {
  const { user, getAuthHeader } = useAuth();
  const [blocks, setBlocks] = useState({});
  const [loaded, setLoaded] = useState(false);

  const isEditor = user?.role === 'super_admin';

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content/public`);
      setBlocks(res.data || {});
    } catch {
      setBlocks({});
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const get = useCallback(
    (key, fallback = '') => (blocks[key] !== undefined ? blocks[key] : fallback),
    [blocks]
  );

  const save = useCallback(
    async (key, value) => {
      await axios.put(`${API}/content/${encodeURIComponent(key)}`, { value }, { headers: getAuthHeader() });
      setBlocks((prev) => ({ ...prev, [key]: value }));
    },
    [getAuthHeader]
  );

  return (
    <ContentContext.Provider value={{ get, save, isEditor, loaded }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
